module.exports = __webpack_public_path__ + "static/img/logon02.529221b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/html/logon02.jpg
// module id = zyLV
// module chunks = 1